<template>
    <el-drawer title="实名信息" :visible.sync="infoVisible" :before-close="closeDialog" size="400px">
        <div class="drawer-content" v-loading="pageLoading">
            <ul v-if="infoForm" class="info-content">
                <li><span class="title">姓名</span><span>{{ infoForm.name }}</span></li>
                <li><span class="title">证件号码</span><span>{{ infoForm.documentNumber }}</span></li>
                <li><span class="title">籍贯</span><span>{{ infoForm.nativePlace }}</span></li>
                <li><span class="title">生日</span><span>{{ infoForm.birthday }}</span></li>
                <li><span class="title">年龄</span><span>{{ `${infoForm.age}  ${infoForm.ageGroup}` }}</span></li>
                <li><span class="title">星座</span><span>{{ infoForm.constellation }}</span></li>
                <li class="last"><span class="title">性别</span><span>{{ infoForm.gender == 1 ? '男' : infoForm.gender == 2 ? '女' : '未知' }}</span></li>
            </ul>
        </div>
        <div class="drawer-footer">
            <el-button @click="closeDialog">关 闭</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    props: {
        infoVisible: {
            type: Boolean,
            default: false
        },
        infoId: {
            type: [Number, String],
            default: null
        }
    },
    watch: {
        infoId(n){
            this.getInfo(n);
        }
    },
    data(){
        return {
            pageLoading: false,
            infoForm: null                
        }
    },
    methods: {
        getInfo(id){
            if(!id) return;
            this.pageLoading = true;
            this.$request({
                url: '/commonPerformer/getIdCard',
                method: "POST",
                params: {id}
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.infoForm = {...result};
                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).catch(() => {
                this.$message.error("请求错误");
            }).finally(()=>{
                this.pageLoading = false;
            })
        },
        closeDialog(){
            this.$emit('update:infoVisible', false);      
        }
    }
}
</script>
<style lang="scss" scoped>
.info-content{
    &>li{
        display: flex;
        border: 1px solid #dcdfe6;
        &:not(.last){
            border-bottom: none;
        }
        span{
            padding: 16px; 
        }
        .title{                  
            width: 120px;
            box-sizing: border-box;
            background: #f5f7fa;
            border-right: 1px solid #dcdfe6;
        }
    }
    
}
</style>